import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { applyTypography, BaseButton, useT } from '@repo/common';
import { ReactComponent as ResetIcon } from '@repo/common/assets/icons/20px/icon_20px_reset.svg';
import { ReactComponent as NavigationLeftIcon } from '@repo/common/assets/icons/20px/icon_20px_navigation-left.svg';

const PaymentFail = () => {
  const t = useT();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleRetry = () => {
    const bookingId = searchParams.get('bookingId');
    if (bookingId) {
      navigate(`/community/kpathport/payments?bookingId=${bookingId}`);
    } else {
      navigate('/community/kpathport/booking');
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className='flex items-center justify-center min-h-screen bg-grayscale-gray00'>
      <div className='flex flex-col gap-[24px] items-center pb-[80px] px-[24px]'>
        {/* Text */}
        <div className='flex flex-col gap-[2px] items-center text-center'>
          <p
            className={`${applyTypography('b20Strong')} text-text-primary`}
            style={{ lineHeight: '1.5' }}
          >
            {t('Payment not completed', '결제가 완료되지 않았습니다')}
          </p>
          <p
            className={`${applyTypography('b16')} text-text-primary`}
            style={{ lineHeight: '1.5' }}
          >
            {t(
              'Please check your payment status or try again.',
              '결제 상태를 확인하거나 다시 시도해주세요.',
            )}
          </p>
        </div>

        {/* Buttons */}
        <div className='flex flex-col gap-[8px] items-center w-[180px]'>
          {/* Try again */}
          <BaseButton
            type='primary'
            size='l'
            htmlType='button'
            typo={false}
            gap='gap-[6px]'
            icon={
              <ResetIcon className='shrink-0 size-[20px] text-text-inverse' />
            }
            onClick={handleRetry}
            textWrapperClass={`${applyTypography(
              'b16Strong',
            )} h-auto flex-none text-text-inverse whitespace-nowrap leading-[1.5]`}
            className='h-[48px] min-w-0 border-0 pl-[12px] pr-[16px] py-[12px] rounded-[8px] w-full bg-green-deep02 hover:bg-green-deep03 transition-colors'
          >
            {t('Try again', '다시 시도')}
          </BaseButton>

          {/* Go back */}
          <BaseButton
            type='text'
            size='l'
            htmlType='button'
            typo={false}
            isStatic
            gap='gap-[6px]'
            icon={
              <div className='flex items-center overflow-clip p-[2px] shrink-0 w-[20px]'>
                <NavigationLeftIcon className='w-full h-full text-grayscale-gray07' />
              </div>
            }
            onClick={handleGoBack}
            textWrapperClass={`${applyTypography(
              'b16Strong',
            )} h-auto flex-none text-grayscale-gray07 whitespace-nowrap leading-[1.5]`}
            className='h-[48px] min-w-0 cursor-pointer border-0 bg-transparent pl-[12px] pr-[16px] py-[12px] rounded-[8px] w-full hover:opacity-70 transition-opacity'
          >
            {t('Go back', '뒤로 가기')}
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default PaymentFail;
